import { EntityAppearanceType } from '@/api/generated/api.enum';
import { COLOR_ERROR, COLOR_GREY, COLOR_SUCCESS, COLOR_TINT, COLOR_WARNING, COLOR_WHITE } from '@/constants';
import { COMPETENCE_DOMAIN_ICON_OPTIONS } from '@/constants/competence-icons.constants';
import type { TAppearanceTab, TEmojiKey } from './entityAppearance.types';

export const APPEARANCE_TABS: TAppearanceTab[] = [
  EntityAppearanceType.text,
  EntityAppearanceType.emoji,
  EntityAppearanceType.icon,
  EntityAppearanceType.image,
];
export const APPEARANCE_COLORS = [
  { key: 'white', value: COLOR_WHITE },
  { key: 'mutedPurple', value: COLOR_GREY },
  { key: 'lightGray', value: '#DCDAE5' },
  { key: 'brown', value: '#99664D' },
  { key: 'sand', value: '#E5A15C' },
  { key: 'yellow', value: '#F2BA00' },
  { key: 'amber', value: '#FA9E00' },
  { key: 'orange', value: COLOR_WARNING },
  { key: 'papaya', value: '#F25824' },
  { key: 'red', value: COLOR_ERROR },
  { key: 'pink', value: '#E53973' },
  { key: 'orchid', value: '#D92BBC' },
  { key: 'purple', value: COLOR_TINT },
  { key: 'blue', value: '#0C59F2' },
  { key: 'skyBlue', value: '#00BDFC' },
  { key: 'turquoise', value: '#14C7B8' },
  { key: 'green', value: COLOR_SUCCESS },
  { key: 'lime', value: '#66BF39' },
];
export {
  DEFAULT_APPEARANCE_COLOR,
  APPEARANCE_IMAGE_MAX_BYTES,
  APPEARANCE_IMAGE_TYPES,
} from 'common/constants/entity.appearance.constants';
export const DEFAULT_EMOJI_KEY: TEmojiKey = '1F600';
export const DEFAULT_EMOJI_UNICODE = '😀';
export const APPEARANCE_ICONS = Object.values(COMPETENCE_DOMAIN_ICON_OPTIONS).flat();
export const DEFAULT_APPEARANCE_ICON = APPEARANCE_ICONS[0];
